import React, { useEffect, useState, useRef } from 'react';
import { QuestionRendererProps } from './types';
import { LatexRenderer } from '../../ui/LatexRenderer';
export function FillInRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const [value, setValue] = useState('');
  const prevValidateRef = useRef(false);
  const config = question.interactiveConfig || {};
  const placeholder = config.placeholder || 'Typ je antwoord...';
  const inputType = config.inputType || 'text'; // 'text' or 'number'
  const unit = config.unit || '';
  // Reset state when question changes
  useEffect(() => {
    setValue('');
    prevValidateRef.current = false;
  }, [question.id]);
  // Reset validation flag when shouldValidate becomes false
  useEffect(() => {
    if (!shouldValidate) {
      prevValidateRef.current = false;
    }
  }, [shouldValidate]);
  useEffect(() => {
    onReadyChange?.(value.trim().length > 0);
  }, [value, onReadyChange]);
  // Rising-edge detection for shouldValidate
  useEffect(() => {
    if (shouldValidate && !prevValidateRef.current) {
      prevValidateRef.current = true;
      // Convert to number if inputType is 'number'
      const answer = inputType === 'number' ? Number(value) : value;
      onAnswer(answer);
    }
  }, [shouldValidate, value, inputType, onAnswer]);
  return <div className="w-full max-w-md mx-auto" data-id="element-4697">
      <div className="flex items-center gap-3" data-id="element-4698">
        <input type={inputType === 'number' ? 'number' : 'text'} value={value} onChange={e => setValue(e.target.value)} placeholder={placeholder} className="flex-1 p-4 text-lg border-2 border-slate-200 rounded-xl focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 outline-none transition-all" autoFocus data-id="element-4699" />

        {unit && <span className="text-lg font-bold text-slate-500" data-id="element-4700">
            <LatexRenderer content={unit} data-id="element-4701" />
          </span>}
      </div>
    </div>;
}